module.exports = __webpack_public_path__ + "static/item--ac--f5@3x.ff040d19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--ac--f5@3x.png
// module id = 623
// module chunks = 126511778744290